import { type NavigationProps } from '@react-native-common/common'

export type NavigationData = NavigationProps['data']
export type NavigationModelVariant = NonNullable<NavigationProps['variant']>

export const NAVIGATION_MODEL_VARIANT = {
  B2B: 'b2b',
  B2C: 'b2c',
} as const satisfies Record<'B2B' | 'B2C', NavigationModelVariant>

export { BASE_B2B_NAVIGATION_MODEL } from './B2B/navigationModel'
export { BASE_B2C_NAVIGATION_MODEL } from './B2C/navigationModel'
